import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getimageAPi, createimageAPi,  uploadimageAPi, deleteimageApi } from "../../../ApiUrl";
import { toast } from "react-toastify";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,   
};
// create image
export const createGelleryImage = createAsyncThunk('createGelleryImage/image', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createimageAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updateGelleryImage = createAsyncThunk('updateGelleryImage/image', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadimageAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get image
export const getGelleryImage = createAsyncThunk('getGelleryImage/image', async () => {
    try {
        const response = await axios.get(`${getimageAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'images' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete image
export const deleteGelleryImages = createAsyncThunk('deleteGelleryImages/image', async (imageid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deleteimageApi}/${imageid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'imageid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const imageSlice = createSlice({
    name: 'image',
    initialState: {
        images: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create image
            .addCase(createGelleryImage.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createGelleryImage.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createGelleryImage.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update image
            .addCase(updateGelleryImage.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateGelleryImage.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(updateGelleryImage.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getGelleryImages
            .addCase(getGelleryImage.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getGelleryImage.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.images = action.payload;
            })
            .addCase(getGelleryImage.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete images
            .addCase(deleteGelleryImages.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteGelleryImages.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.images.data = state.images.data.filter(images => images.imageid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deleteGelleryImages.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default imageSlice.reducer;
